export default{sources:{avif:"__VITE_ASSET__BxYt8heO__ 400w",webp:"__VITE_ASSET__DLNk7NnI__ 400w"},img:{src:"__VITE_ASSET__HgTM8FOo__",w:400,h:711}};